import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TASK_SERVICE } from '@eggplant/api-hosts'
import type { GetTaskResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  taskId: string
  children?: (data: GetTaskResponse) => ReactElement
}

const GetTaskRequest = ({
  taskId,
  children
}: Props) => {
  const url = `${TASK_SERVICE}/task/${taskId}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      url={url}
    />
  )
}

export default GetTaskRequest
